<template>
  <div class="content-box">
    <div class="content-body contant-wrap">
      <el-card style="margin-bottom: 20px">
        <el-form :inline="true">
          <el-form-item label="类型：">
            <el-select v-model="form.medType" placeholder="请选择" class="input" @change="getSettlementList(form)">
              <el-option label="普通门诊" :value="11" />
              <el-option label="独立门诊部个人帐户支付" :value="9935" />
              <el-option label="定点药店购药" :value="41" />
            </el-select>
          </el-form-item>
          <el-form-item label="日期：">
            <el-date-picker v-model="time" type="daterange" align="right" unlink-panels range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions" @change="changeTime" style="width: 280px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="form.orderNo" placeholder="请输入订单号" class="input" clearable></el-input>
          </el-form-item>

          <el-form-item label="姓名：">
            <el-input v-model="form.psn_name" placeholder="请输入姓名" class="input" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="form.fixmedins_refd_setl_flag" placeholder="请选择" class="input">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="清算类别">
            <el-select v-model="form.clr_type" placeholder="请选择" class="input">
              <el-option v-for="item in clrtypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getSettlementList(form)" type="primary">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="exportSettlement">导出</el-button>
          <!-- <el-button type="primary">打印</el-button> -->
          <!-- <SelectColTable
            style="float: right"
            :select-options="rowList"
            @change="getTableCol"
          ></SelectColTable> -->
        </div>
        <el-table :data="tableData" style="width: 100%" v-loading="loading">
          <el-table-column prop="orderNo" label="订单号" align="center" width="200"></el-table-column>
          <el-table-column prop="psnName" label="人员姓名" align="center"> </el-table-column>
          <!-- <el-table-column prop="psnNo" label="人员编号" align="center"> </el-table-column> -->
          <el-table-column prop="psnTypeLabel" label="人员类别" align="center"></el-table-column>
          <el-table-column prop="medfeeSumamt" label="医疗费总额" align="center"></el-table-column>
<!--          <el-table-column prop="setlId" label="结算id" align="center"> </el-table-column>-->
<!--          <el-table-column prop="mdtrtId" label="就诊id" align="center"> </el-table-column>-->
<!--          <el-table-column prop="certno" label="证件号" :show-overflow-tooltip="true" align="center"> </el-table-column>-->
          <el-table-column prop="fundPaySumamt" label="基金支付总额" align="center"> </el-table-column>
          <el-table-column prop="acctPay" label="个账支出" align="center"> </el-table-column>
          <el-table-column prop="acctMulaidPay" label="共济支付" align="center"> </el-table-column>
          <el-table-column prop="psnCashPay" label="现金支出" align="center"> </el-table-column>
          <el-table-column prop="setlTime" label="结算时间" width="200" align="center">
          </el-table-column>
          <el-table-column prop="clrTypeLabel" label="清算类别" align="center"> </el-table-column>
          <el-table-column prop="fixmedinsRefdSetlFlag" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.fixmedinsRefdSetlFlag == '0'">结算成功</span>
              <span v-if="scope.row.fixmedinsRefdSetlFlag == '1'">已撤销</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" width="260" align="center">
            <template slot-scope="scope">
               <!--撤销结算融合在系统的退费里面了-->
              <!--<el-button :disabled="scope.row.fixmedinsRefdSetlFlag == '1'" @click="openRevokeDialog(scope.row)"-->
              <!--  type="text">撤销结算</el-button>-->
              <!--<el-button :disabled="scope.row.fixmedinsRefdSetlFlag == '1'" @click="openRevokeDialogNew(scope.row)"-->
              <!--           type="text">撤销结算</el-button>-->
              <el-button @click="handleClick(scope.row.orderNo, '预览')" type="text">预览</el-button>
              <el-button @click="handleClick(scope.row.orderNo, '打印')" type="text">打印</el-button>
              <el-button @click="gotoDetail(scope.row)" type="text">详情</el-button>
              <el-button @click="handleSynchronization(scope.row.orderNo)" type="text">同步时间</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination tableFooter" v-if="tableData.length > 0">
          <div>
            <b>合计:</b>&emsp;
            医疗费用:&nbsp;￥{{ medfeeSumamt }}&nbsp;
            基金支付:&nbsp;￥{{ fundPaySumamt }}&nbsp;
            个账支出:&nbsp;￥{{ acctPay }}&nbsp;
            共济支付:&nbsp;￥{{ acctMulaidPay }}&nbsp;
            现金支出:&nbsp;￥{{ psnCashPay }}&nbsp;
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="form.page" :page-sizes="pageSizes" :page-size.sync="form.limit"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </el-card>
      <el-dialog width="30%" title="请选择结算撤销方式" :visible.sync="readVisible" :close-on-click-modal="false"
        :before-close="handleClose">
        <div style="width: 100%;display: flex;justify-content: center;">
          <el-radio-group v-model="revokeType" @input="selectRadio">
            <el-radio :label="1" border>电子凭证</el-radio>
            <el-radio v-if="cityName != '合肥'" :label="2" border>身份证</el-radio>
            <el-radio :label="3" border>社保卡</el-radio>
          </el-radio-group>
        </div>
        <el-row type="flex" justify="center" style="margin: 50px 0">
          <img src="../../../assets/home/Vector@2x.png" style="width: 180px; height: 112px" />
        </el-row>
      </el-dialog>
      <!-- 医保结算单据打印 -->
      <ybjs-print style="display: none;" ref="ybjsPrintRef" :record="record" :is-review="review"></ybjs-print>
    </div>
  </div>
</template>

<script>
import { pageSizes, pickerOptions } from "@/config/constant";
// import SelectColTable from "@/components/SelectColTable.vue";
import { startDateWeek } from '@/utils/filter';
import { getLodop } from '@/plugins/LodopFuncs';
import ybjsPrint from '@/components/ybjsPrint/index';
// import ybjsPrint from '../../../components/ybjsPrint/index.vue';
import Store from "@/utils/localStore/index";
import {revokeSettlementDrugAPI} from "@/api/newInsurance";
export default {
  name: "settlementDocument",
  components: { ybjsPrint },
  data () {
    return {
      name: "", //姓名
      review: false,
      time: [], //日期
      options: [
        {
          value: "0",
          label: "结算成功",
        },
        {
          value: "1",
          label: "已撤销",
        }
      ],
      value: "",
      clrtypeList: [],
      type: "",
      tableData: [],
      pageSizes,
      pickerOptions,
      total: 0, //总条数
      medfeeSumamt: 0,
      fundPaySumamt: 0,
      psnCashPay: 0,
      acctMulaidPay: 0,
      acctPay: 0,
      form: {
        medType: 11,
        limit: 20,
        page: 1,
        clr_type: "",
        psn_name: "",
        setl_time_start: startDateWeek()[0],
        setl_time_end: startDateWeek()[1],
        fixmedins_refd_setl_flag: "",//状态
      },
      rowList: [
        {
          name: "出入库-数量",
          value: "changeNumbers",
          minWidth: "100",
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: "实时数量",
          value: "inventoryCountNow",
          minWidth: "",
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: "操作人",
          value: "modifier",
          minWidth: "",
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: "批号",
          value: "drugBatchNo",
          minWidth: "",
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: "有效期",
          value: "validityDate",
          minWidth: "",
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: "进货价",
          value: "purchasePrice",
          minWidth: "",
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: "零售价",
          value: "salePrice",
          minWidth: "",
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: "货架码",
          value: "goodsShelfCode",
          minWidth: "88",
          isSortable: true,
          disabled: false,
          checked: true,
        },
      ],
      exportQuery: {

      },
      loading: false,
      record: {},
      readVisible: false,
      revokeType: '',
      revokeForm: {
        mdtrt_cert_type: '',
        mdtrt_cert_no: '',
        card_sn: '',
        psn_cert_type: '',
        certno: '',
        psn_name: ''
      },
      orderNo: ''
    };
  },
  mounted () {
    this.time = startDateWeek()
    this.getclrtypeList()
    this.getChargesConfig()
  },
  methods: {
    handleSynchronization(orderNo) {
      this.$api.newInsurance.getSynchronization(orderNo).then(res => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: '操作成功',
          });
          this.getSettlementList(this.form);
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },
    handleClick (orderNo, type) {

      // 定点药店购药就掉这个接口 getPrintDrugAPI
      let getPrintFn = (orderNo) => {
        if (this.form.medType == 41) {
          return this.$api.newInsurance.getPrintDrugAPI(orderNo)
        } else {
          return this.$api.newInsurance.getPrintAPI(orderNo)
        }
      }

      // this.review=true
      getPrintFn({ orderNo: orderNo }).then(res => {
        if (res.data.code === 200) {
          this.record = res.data.data
          if (type === '预览') {
            // this.$notify({title: '友情提示',message: '正在打印请稍后...',type: 'success',});
            this.$refs.ybjsPrintRef.print({ isReview: true });
          } else {
            this.$notify({ title: '友情提示', message: '正在打印请稍后...', type: 'success', });
            this.$refs.ybjsPrintRef.print();
          }

        } else {
          //  return this.$notify({title: '友情提示',message: '未获取门诊结算信息...',type: 'error',});
          return this.$notify({ title: '友情提示', message: res.data.message, type: 'error', });
        }
      })

    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`);
      this.form.limit = val;
      this.getSettlementList(this.form);
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getSettlementList(this.form);
    },
    getTableCol (e) {
      this.rowList = e;
    },
    // 获取结算列表
    getSettlementList (obj) {
      this.loading = true
      this.$api.newInsurance.getSettlementListAPI(obj).then((res) => {
        console.log(res, "结算列表");
        console.log(res.data)
        const { data } = res.data;
        console.log(data)
        if(data.page) {
          this.tableData = data.page.records || []
        }else {
          this.tableData = [];
        }
        // console.log('data.records: ', data.records);
        this.medfeeSumamt = data.medfeeSumamt;
        this.fundPaySumamt  = data.fundPaySumamt;
        this.psnCashPay = data.cashPaySumamt;
        this.acctMulaidPay = data.jointPaySumamt;
        this.acctPay = data.personalPaySumamt;
        this.total = data.page.total;
        this.loading = false;
      });
    },
    //临时使用
    openRevokeDialogNew (item) {
      const params = {
        orderNo: item.orderNo
      }
      // 药店结算撤销
      this.$api.newInsurance.revokeSettlementDrugAPI(params);
    },
    openRevokeDialog (item) {
      this.orderNo = item.orderNo
      this.readVisible = true;
    },
    // 结算撤销
    async revokeSettlement () {
      const params = {
        // setl_id: item.setlId,
        // mdtrt_id: item.mdtrtId,
        orderNo: this.orderNo,
        ...this.revokeForm
      }
      // console.log(params,'结算撤销参数');

      // 定点药店购药就掉这个接口 revokeSettlementDrugAPI
      let getSettlementRevokeFn = (params) => {
        if (this.form.medType == 41) {
          return this.$api.newInsurance.revokeSettlementDrugAPI(params)
        } else {
          return this.$api.newInsurance.revokeSettlementAPI(params)
        }
      }

      const res = await getSettlementRevokeFn(params)
      // console.log(res,'结算撤销');
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: res.data.message,
        });
        this.getSettlementList(this.form);
      } else {
        this.$message({
          type: "error",
          message: res.data.message,
        });
      }

    },
    // 导出
    exportSettlement () {
      this.$api.newInsurance.exportSettlementAPI(this.form)
    },
    changeTime (e) {
      this.form.setl_time_start = e[0]
      this.form.setl_time_end = e[1]
    },
    getclrtypeList () {
      this.$api.newInsurance.getDictionaryByClinicAPI(
        { type: 'CLR_TYPE' }
      ).then(res => {
        // console.log(res,'res');
        this.clrtypeList = res.data.data
      })
    },
    gotoDetail (item) {
      let path = item.medType == 41 ? '/medicalInsurance/settlementDrugDetail' : '/medicalInsurance/settlementDetail'

      this.$router.push({
        path,
        query: {
          orderNo: item.orderNo,
        }
      })
    },
    handleClose () {
      this.readVisible = false;
      this.revokeType = ''
    },
    async selectRadio (val) {
      if (val == '1') {
        // 电子凭证
        this.revokeForm.mdtrt_cert_type = "0" + val;
        await this.getElectronicVoucher()
        await this.revokeSettlement()
        this.readVisible = false
        this.revokeType = ''
      } else if (val == '2') {
        // 居民身份证
        this.revokeForm.mdtrt_cert_type = "0" + val;
        this.revokeForm.psn_cert_type = "01";//居民身份证
        await this.initReadCard();
        await this.getIdCode()
        await this.revokeSettlement()
        this.readVisible = false
        this.revokeType = ''
      } else {
        // 社保卡
        this.revokeForm.mdtrt_cert_type = "0" + val;
        this.revokeForm.psn_cert_type = "90";//社会保障卡
        await this.initReadCard();
        await this.getSbCode()
        await this.revokeSettlement()
        this.readVisible = false
        this.revokeType = ''
      }
    },
    async initReadCard () {
      const { fixMedIns } = Store.get("vuex").global.countInfo
      const params = {
        url: fixMedIns.apiUrl,
        User: fixMedIns.useArea,
      };
      await this.$api.newInsurance.initReadCardAPI(params)
    },
    // 读取身份证号
    async getIdCode () {
      const res = await this.$api.newInsurance.getCardNoAPI()
      if (res.data.code == 0) {
        this.$message({
          type: "success",
          message: "读取身份证号成功",
        });
        // console.log(res, "获取身份证号");
        const { model } = res.data;
        this.revokeForm.psn_name = model.name;
        this.revokeForm.mdtrt_cert_no = model.cardNo;
        this.revokeForm.certno = model.cardNo;
        // console.log(this.revokeForm,'revokeForm');
      } else {
        this.revokeType = ''
        this.$message({
          type: "error",
          message: "读取身份证号失败，请检查是否放置身份证",
        });
      }
    },
    // 读取社保卡号
    async getSbCode () {
      const res = await this.$api.newInsurance.getSocialCardNoAPI()
      if (res.data.code == 0) {
        this.$message({
          type: "success",
          message: "读取社保卡号成功",
        });
        // console.log(res, "获取社保卡号");
        const { model } = res.data;
        this.revokeForm.psn_name = model.name;
        this.revokeForm.mdtrt_cert_no = model.cardNo;
        this.revokeForm.card_sn = model.identificationNo;
        this.revokeForm.certno = model.shbzhmSocialSecurityNo;
        this.revokeForm.psn_name = model.name;
        // console.log(this.revokeForm,'revokeForm');
      } else {
        this.revokeType = ''
        this.$message({
          type: "error",
          message: "读取社保卡号失败",
        });
      }
    },
    // 电子凭证
    async getElectronicVoucher () {
      const { fixMedIns } = Store.get("vuex").global.countInfo
      const { countInfo } = Store.get("vuex").global
      const query = {
        data: {
          // businessType:'01101',
          businessType: '01301',
          deviceType: '',
          officeId: '32760',
          officeName: '消化内科',
          operatorId: countInfo.doctorId,
          operatorName: countInfo.doctorName,
          orgId: fixMedIns.fixmedinsCode
        },
        orgId: fixMedIns.fixmedinsCode,
        transType: 'ec.query'
      }
      const params = {
        url: fixMedIns.tradeUrl,
        data: JSON.stringify(query),
      };
      // console.log(params, "电子凭证获取信息");
      const res = await this.$api.newInsurance.getElectronicVoucherAPI(params)
      console.log(res, "读取电子凭证");
      if (res.data.code == 0) {
        this.$message({
          type: "success",
          message: "电子凭证获取信息成功",
        });
        const { data } = res.data;
        this.revokeForm.mdtrt_cert_no = data.ecToken;
        this.revokeForm.psn_cert_type = data.idType;
        this.revokeForm.certno = data.idNo;
        this.revokeForm.psn_name = data.userName;
        // console.log(this.revokeForm,'revokeForm');
      } else {
        this.revokeType = ''
        this.$message({
          type: "error",
          message: "电子凭证获取信息失败",
        });
      }
    },
    reduceTotal(target) {
      let sum = this.tableData.reduce((prev, item)=>{
        return prev + Number(item[target]);
      }, 0)
      return (sum).toFixed(2)
    },
    async getChargesConfig () {
      // let res = await this.$api.clinicManagement.getHospitalConfig({ configType: 12, })
      this.form.medType = 11
      this.getSettlementList(this.form);
    },
  },
  computed: {
    cityName () {
      const { countInfo } = Store.get("vuex").global
      return countInfo.city ? countInfo.city : ''
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-loading-spinner {
  top: 80px;
}

::v-deep .el-radio--medium.is-bordered {
  margin: 0;
}

.input {
  width: 156px;
}
.tableFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:0 40px 0 0;
  flex-wrap: wrap;
}
</style>